import axios from 'axios';
import config from '../config';
import { getStoredAccessToken } from '../auth/session';

let unauthorizedHandler = () => {};

export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = typeof handler === 'function' ? handler : () => {};
}

const client = axios.create({
  baseURL: config.apiBaseUrl,
  timeout: 15000,
});

client.interceptors.request.use((request) => {
  const token = getStoredAccessToken();
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      unauthorizedHandler();
    }
    return Promise.reject(error);
  }
);

export default client;
